// Dashboard.jsx

import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { useSocket } from '../../context/SocketContext';
import { toast } from 'react-toastify';
import axios from 'axios';
import { API_BASE_URL, API_BASE_PYTHON_SERVICE } from '../../utils/config';
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import MapSection from './MapSection/MapSection';
import DataSection from './DataSection/DataSection';
import Tutorial from '../../components/Tutorial/Tutorial';
import ToolbarComponent from "../../components/ToolbarComponent/ToolbarComponent";
import FilterToolbar from "../../components/FilterToolbar/FilterToolbar";
import { Box, CircularProgress } from '@mui/material';
import { sendDashboardData, construirPayloadReporte } from '../../utils/DashboardUtils';
import LoadingBar from "../../components/LoadingBar/LoadingBar";
import {
    DashboardContainer,
    MainContent,
    DashboardControls,
    MapSectionContainer,
    AnalysisSection,
} from './DashboardStyle';
import { SidebarContext } from "../../context/SidebarContext";
import analysisConfig from "../../utils/analysisConfig";
import sidebarOptionsConfig from "../../utils/sidebarOptionsConfig";
import { manejarSubidaArchivo } from "../../utils/fileHandler";
import { obtenerLoteMasReciente, insertarUltimoAnalisis } from "../../utils/mapUtils";
import {
    generarLineasPisoteoEnSegundoPlano,
    ejecutarProcesoSinArchivoCosechaMecanica,
    lanzarCosechaMecanicaEnSegundoPlano
} from "../../analysis/cosechaMecanica/cosechaMecanicaProcess";
import { ejecutarProcesoAps } from "../../analysis/aps/apsProcess";
import {
    ejecutarProcesoHerbicidas,
    ejecutarProcesoSinArchivoHerbicidas
} from "../../analysis/herbicidas/herbicidasProcess";
import {
    ejecutarProcesoFertilizacion,
    ejecutarProcesoSinArchivoFertilizacion
} from "../../analysis/fertilizacion/fertilizacionProcess";
import { ejecutarProcesoConteoPalmas } from "../../analysis/conteoPalmas/conteoPalmasProcess";
import { ejecutarProcesoConteoAgaves } from "../../analysis/conteoAgave/conteoAgaveProcess";
import { ejecutarProcesoDeteccionMaleza } from "../../analysis/deteccionMaleza/deteccionMalezaProcess";
import { ejecutarPlanificacionCosecha } from "../../analysis/planificacionCosechaProcess/planificacionCosechaProcess";
import { ejecutarPlanificacionHerbicidas } from "../../analysis/PlanificacionHerbicidasProcess/PlanificacionHerbicidasProcess";
import {
    APLICACIONES_AEREAS,
    COSECHA_MECANICA,
    HERBICIDAS,
    FERTILIZACION,
    CONTEO_PALMA,
    CONTEO_AGAVE,
    DETECCION_MALEZA,
    PLANIFICACION_COSECHA
} from '../../utils/Constants';

import { CompanyContext } from "../../context/CompanyContext";
import ErrorListDialog from "../../components/ErrorListDialog/ErrorListDialog";
import AnalisisJobsPanel from "../../components/AnalisisJobsPanel/AnalisisJobsPanel";
import { notificarConsumoAps } from "../../utils/creditosAps";
import { enviarReporteJob, fijarJobEnUrl, marcarJobVisto } from "../../utils/analisisJobs";
import { capturarAcercamientos, capturarCanvas, encuadrarAnalisis, esperarMapaQuieto, obtenerMapa } from "../../utils/capturaMapa";
import { esperarRedQuieta, instalarContadorDeRed, mapaTieneAnalisis, reportarEstado } from "./reporteAutomatico";


const GENERATED_PDF_IDS_STORAGE_KEY = 'geomotica_generated_pdf_ids';

const readGeneratedPdfIds = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem(GENERATED_PDF_IDS_STORAGE_KEY) || '[]');
        return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch {
        return [];
    }
};

const persistGeneratedPdfIds = (ids) => {
    try {
        localStorage.setItem(GENERATED_PDF_IDS_STORAGE_KEY, JSON.stringify(Array.from(new Set(ids.map(String)))));
    } catch {
        // No bloquear la UI si localStorage no está disponible.
    }
};

const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// replayCtx: análisis en segundo plano ya terminado que se vuelve a mostrar
// (al reabrirlo, o en el Chrome sin pantalla del worker con modoReporte,
// que además genera y entrega el PDF solo).
const Dashboard = ({ isSidebarOpen, selectedFiles, selectedFilters, setSelectedFilters, replayCtx = null, modoReporte = false, tokenReporte = null }) => {
    const { logo } = useContext(CompanyContext);
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    const [runTutorial, setRunTutorial] = useState(false);
    const [tutorialKey, setTutorialKey] = useState(0);
    const [progress, setProgress] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [idMax, setIdMax] = useState(null);
    const [generatedPdfIds, setGeneratedPdfIds] = useState(readGeneratedPdfIds);
    const [processingFinished, setProcessingFinished] = useState(false);
    const [titleLoader, setTitleLoader] = useState("");
    const [idAnalisisAps, setIdAnalisisAps] = useState(null);
    const [idAnalisisCosechaMecanica, setIdAnalisisCosechaMecanica] = useState(null);
    const [idAnalisisFertilizacion, setIdAnalisisFertilizacion] = useState(null);
    const [idAnalisisHerbicidas, setIdAnalisisHerbicidas] = useState(null);
    const [idAnalisisBash, setIdAnalisisBash] = useState(null);
    const [refreshAnalisis, setRefreshAnalisis] = useState(null);
    const [refreshPeticion, setRefreshPeticion] = useState(null);
    const [idAnalisisUltimoAnalisis, setIdAnalisisUltimoAnalisis] = useState(null);
    const selectedAnalysisTypeRef = useRef();
    const replayAnalisisRef = useRef(replayCtx || null);
    if (modoReporte) instalarContadorDeRed();
    const [progressMessage, setProgressMessage] = useState("");
    const [selectedZipFile, setSelectedZipFile] = useState(null);
    // Archivo adicional usado solo por Aplicaciones Aéreas en modo VAR / Tasa Variable.
    // Debe vivir en Dashboard para que el botón Analizar pueda habilitarse correctamente.
    const [selectedApsTargetPolygonFile, setSelectedApsTargetPolygonFile] = useState(null);
    const [uploadedApsTargetPolygonFileName, setUploadedApsTargetPolygonFileName] = useState('');
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [datosMapeo, setDatosMapeo] = useState([]);
    const [areaAplicada, setAreaAplicada] = useState(0);
    const [areaTotalLote, setAreaTotalLote] = useState(0);
    const [porcentajeVariacion, setPorcentajeVariacion] = useState(0);
    const [porcentajeVariacionDosis, setPorcentajeVariacionDosis] = useState(0);
    const [areaNoAplicada, setAreaNoAplicada] = useState(0);
    const [promedioVelocidad, setPromedioVelocidad] = useState(0);
    const [promedioAltura, setPromedioAltura] = useState(0);
    const [areaNetaCm, setAreaNetaCm] = useState(null);
    const [areaBrutaCm, setAreaBrutaCm] = useState(null);
    const [diferenciaDeAreaCm, setDiferenciaDeAreaCm] = useState(null);
    const [eficienciaCm, setEficienciaCm] = useState(null);
    const [promedioVelocidadCm, setPromedioVelocidadCm] = useState(null);
    const [porcentajeAreaPilotoCm, setPorcentajeAreaPilotoCm] = useState(null);
    const [areaSobreAplicada, setAreaSobreAplicada] = useState(0);
    const [areaSobreCalles, setAreaSobreCalles] = useState(0);
    const [areaFueraDeLote, setAreaFueraDeLote] = useState(0);
    const [dosisTotalRealAplicada, setDosisTotalRealAplicada] = useState(0);
    const [porcentajeAreaAutoTrackerCm, setPorcentajeAreaAutoTrackerCm] = useState(null);
    const [porcentajeModoCortadorBaseCm, setPorcentajeModoCortadorBaseCm] = useState(null);

    const [datosAnalisis, setDatosAnalisis] = useState({});
    const [isKMLFile, setIsKMLFile] = useState(false);
    const [activarEdicionInteractiva, setActivarEdicionInteractiva] = useState(true);
    const [selectedAnalysisType, setSelectedAnalysisType] = useState(replayCtx?.tipoAnalisis || '');
    const dashboardRef = useRef();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [uploadedCsvFileName, setUploadedCsvFileName] = useState('');
    const [uploadedZipFileName, setUploadedZipFileName] = useState('');
    const [execBashEnabled, setExecBashEnabled] = useState(false);
    const [apsManualRowsVersion, setApsManualRowsVersion] = useState(0);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [polygonsData, setPolygonsData] = useState([]);
    const [lotesGeojson, setLotesGeojson] = useState(null);
    const [activeLotes, setActiveLotes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loadingFilters, setLoadingFilters] = useState(true);
    const [loadingPolygons, setLoadingPolygons] = useState(true);
    const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
    const socketContext = useSocket();
    const { socket, socketSessionID } = socketContext || {};
    const [indicadores, setIndicadores] = useState('');
    const [imgLaflet, setImgLaflet] = useState(null);
    const { selectedSidebarOption } = useContext(SidebarContext) || {};
    const [filterOptions, setFilterOptions] = useState([
        { value: 'operadorCM', label: 'Operador' },
        { value: 'zafraCM', label: 'Zafra' },
        { value: 'loteCM', label: 'Lote' },
        { value: 'fincaCM', label: 'Finca' },
        { value: 'tercioCM', label: 'Tercio' },
        { value: 'productoAA', label: 'Producto' },
    ]);
    const [enabledFilters, setEnabledFilters] = useState([]);
    const [analysisOptions, setAnalysisOptions] = useState([]);
    const [ultimoAnalisis, setUltimoAnalisis] = useState(null);
    const [imageUrl, setImageUrl] = useState('');
    const [diferenciaDeAreaApsKml, setDiferenciaDeAreaApsKml] = useState(null);
    const [northWestCoords, setNorthWestCoords] = useState(null);
    const [southEastCoords, setSouthEastCoords] = useState(null);
    const [coordinateSystem, setCoordinateSystem] = useState("EPSG:4326");

    const [conteoObjetos, setConteoObjetos] = useState(0);

    const [areaMaleza, setAreaMaleza] = useState(0);
    const [porcentajeMaleza, setPorcentajeMaleza] = useState(0);
    const [areaPoligono, setAreaPoligono] = useState(0);

    const [highlightedLote, setHighlightedLote] = useState(null);
    const [isAnalysisPerformed, setIsAnalysisPerformed] = useState(false);
    const [isGeneratingReport, setIsGeneratingReport] = useState(false);
    const [labelsAndColors, setLabelsAndColors] = useState({});
    const mapRef = useRef(null);
    const polygonsLayerRef = useRef(null);
    const dataSectionRef = useRef(null);
    const undoHandlerRef = useRef(null);
    const [onAreasCalculatedLoader, setOnAreasCalculatedLoader] = useState(true);
    const [tipoMapeo, setTipoMapeo] = useState('');
    const [errors, setErrors] = useState([]);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);

    const [operadorOptionsCM, setOperadorOptionsCM] = useState([]);
    const [zafraOptionsCM, setZafraOptionsCM] = useState([]);
    const [loteOptionsCM, setLoteOptionsCM] = useState([]);
    const [fincasOptionsCM, setFincasOptionsCM] = useState([]);
    const [tercioOptionsCM, setTercioOptionsCM] = useState([]);
    const [productoOptionsAA, setProductoOptionsAA] = useState([]);
    const [tramplingLines, setTramplingLines] = useState([]);
    const [activeTool, setActiveTool] = useState(null);
    const [isBufferActive, setIsBufferActive] = useState(false);
    const [bufferValue, setBufferValue] = useState(() => {
        const raw = localStorage.getItem('aps_buffer_width_m');
        const n = raw != null ? Number(String(raw).replace(',', '.')) : NaN;
        return Number.isFinite(n) && n > 0 ? n : null;
    });
    const [showUnfilteredLines, setShowUnfilteredLines] = useState(true);
    const [mostrarLineas, setMostrarLineas] = useState(false);
    const [calidad, setCalidad] = useState('baja');
    const [precioPlantacion, setPrecioPlantacion] = useState(0);
    const [costosPlantacion, setCostosPlantacion] = useState(0);
    const [utilidadNeta, setUtilidadNeta] = useState(0);
    const [previousTramplingLines, setPreviousTramplingLines] = useState([]);
    const [harvestLinesBuffer, setHarvestLinesBuffer] = useState(0);
    const [disableAnalysisSelection, setDisableAnalysisSelection] = useState(false);
    const [forceEnableUploadTemplate, setForceEnableUploadTemplate] = useState(false);
    const [polygonsHarvestPlanning, setPolygonsHarvestPlanning] = useState([]);
    const [polygonsHerbicidesPlanning, setPolygonsHerbicidesPlanning] = useState([]);
    const [fertilizacionShapefileUrl, setFertilizacionShapefileUrl] = useState(null);

    const [loteFilters, setLoteFilters] = useState({
        loteId: [],
        finca: [],
        codigoFinca: [],
        lote: [],
    });

    const [appliedLoteFilters, setAppliedLoteFilters] = useState({
        loteId: [],
        finca: [],
        codigoFinca: [],
        lote: [],
    });

    function toCleanStr(v) {
        if (v === null || v === undefined) return '';
        return String(v).trim();
    }

    // ✅ Normaliza cualquier entrada de filtros a un array de strings limpios
    // Acepta: string | number | null | undefined | array
    function toCleanArr(v) {
        if (Array.isArray(v)) {
            return v.map(toCleanStr).filter(Boolean);
        }
        const s = toCleanStr(v);
        return s ? [s] : [];
    }

    function normalizeForUniq(s) {
        return String(s)
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ');
    }

    function getAnyPropValues(obj, candidateKeys) {
        if (!obj) return [];

        // Mapa de keys normalizadas -> key real
        const map = {};
        Object.keys(obj).forEach((k) => {
            map[normalizeKeyLoose(k)] = k;
        });

        for (const k of candidateKeys) {
            const realKey =
                Object.prototype.hasOwnProperty.call(obj, k) ? k : map[normalizeKeyLoose(k)];

            if (!realKey) continue;

            const v = obj[realKey];
            if (Array.isArray(v)) {
                return v.map(toCleanStr).filter(Boolean);
            }
            const s = toCleanStr(v);
            return s ? [s] : [];
        }

        return [];
    }

    function normCmp(v) {
        return normalizeForUniq(String(v ?? ""));
    }


    // ✅ Siempre guardamos los filtros NO-dashboard como arrays:
    // { loteId: string[], finca: string[], codigoFinca: string[], lote: string[] }
    function sanitizeLoteFilters(raw) {
        return {
            loteId: toCleanArr(raw?.loteId),
            finca: toCleanArr(raw?.finca),
            codigoFinca: toCleanArr(raw?.codigoFinca),
            lote: toCleanArr(raw?.lote),
        };
    }

    function hasAnyLoteFilter(f) {
        const ff = f || {};
        return ['loteId', 'finca', 'codigoFinca', 'lote'].some((k) => {
            const v = ff[k];
            return Array.isArray(v) ? v.length > 0 : !!toCleanStr(v);
        });
    }

    function normalizeKeyLoose(k) {
        return normalizeForUniq(String(k ?? '')).replace(/[^a-z0-9]/g, '');
    }

    function getAnyPropValue(obj, candidateKeys) {
        if (!obj) return '';

        const map = {};
        Object.keys(obj).forEach((k) => {
            map[normalizeKeyLoose(k)] = obj[k];
        });

        for (const k of candidateKeys) {
            const v = map[normalizeKeyLoose(k)];
            const s = toCleanStr(v);
            if (s) return s;
        }
        return '';
    }

    function matchLote(propsOrRow, f) {
        const p = propsOrRow?.properties || propsOrRow || {};

        const toNormSet = (arr) => new Set((arr || []).map(normCmp).filter(Boolean));

        const idSet = toNormSet(f?.loteId);
        const fincaSet = toNormSet(f?.finca);
        const codSet = toNormSet(f?.codigoFinca);
        const loteSet = toNormSet(f?.lote);

        // ID
        if (idSet.size > 0) {
            const rowIds = getAnyPropValues(p, [
                // IDs estándar del sistema
                'LOTE_ID','LOTEID','LoteID','loteId',
                'ID_LOTE','id_lote','lote_id',
                // ESRI/ArcGIS
                'OBJECTID','OBJECTID_1','OID','oid','FID','fid',
                // IDs genéricos
                '_id','id','ID'
            ]);
            if (!rowIds.some((x) => idSet.has(normCmp(x)))) return false;
        }

        // N. FINCA (incluye N_FINCAS)
        if (fincaSet.size > 0) {
            const rowFincas = getAnyPropValues(p, [
                'N. FINCA','N FINCA','N_FINCA','NFINCA',
                'N_FINCAS','NFINCAS',               // 👈 CLAVE
                'Nombre Fin','NOMBRE FIN','NOMBRE_FIN',
                'Nombre Finca','NOMBRE_FINCA','NOMBRE FINCA',
                'FINCA_NOMBRE','FINCA_NAME'
            ]);
            if (!rowFincas.some((x) => fincaSet.has(normCmp(x)))) return false;
        }

        // C. FINCA (incluye C_FINCAS)
        if (codSet.size > 0) {
            const rowCods = getAnyPropValues(p, [
                'C. FINCA','C FINCA','C_FINCA','CFINCA',
                'C_FINCAS','CFINCAS',               // 👈 CLAVE
                'FINCA','finca',
                'CODIGO_FINCA','COD_FINCA','FINCA_CODIGO','CODIGO DE FINCA'
            ]);
            if (!rowCods.some((x) => codSet.has(normCmp(x)))) return false;
        }

        // LOTE
        if (loteSet.size > 0) {
            const rowLotes = getAnyPropValues(p, ['LOTE N','LOTE_N','LOTEN','LOTE','lote','Lote','NUM_LOTE','LOTE_NUM','LOTES','LOTE 1','LOTE_1','LOTE1']);
            if (!rowLotes.some((x) => loteSet.has(normCmp(x)))) return false;
        }

        return true;
    }



    function normalizeToFeaturesArray(maybeGeojson) {
        if (!maybeGeojson) return [];
        if (maybeGeojson?.data?.features && Array.isArray(maybeGeojson.data.features)) return maybeGeojson.data.features;
        if (maybeGeojson?.features && Array.isArray(maybeGeojson.features)) return maybeGeojson.features;
        if (Array.isArray(maybeGeojson)) return maybeGeojson;
        return [];
    }

    const filteredPolygonsData = React.useMemo(() => {
        let rows = Array.isArray(polygonsData) ? polygonsData : [];

        // 1) Filtros del FilterToolbar (ID / N. FINCA / C. FINCA / LOTE)
        if (hasAnyLoteFilter(appliedLoteFilters)) {
            rows = rows.filter((row) => matchLote(row, appliedLoteFilters));
        }

        // 2) Selección por CLICK (activeLotes) también debe afectar el cálculo de áreas
        if (Array.isArray(activeLotes) && activeLotes.length > 0) {
            const selectedSet = new Set(activeLotes.map((v) => String(v ?? '')));
            rows = rows.filter((row) => {
                const p = row?.properties || row || {};
                const rowId = getAnyPropValue(p, [
                    // IDs estándar del sistema
                    'loteId','LOTE_ID','LOTEID','LoteID',
                    'ID_LOTE','id_lote','lote_id',
                    // Variantes comunes en datos externos
                    'LOTE N','LOTE_N','LOTEN',
                    'LOTE','lote','Lote','NUM_LOTE','LOTE_NUM','LOTES',
                    'LOTE 1','LOTE_1','LOTE1',
                    // ESRI/ArcGIS
                    'OBJECTID','OBJECTID_1','OID','oid','FID','fid',
                    // IDs genéricos
                    '_id','id','ID'
                ]);
                return selectedSet.has(String(rowId ?? ''));
            });
        }

        return rows;
    }, [polygonsData, appliedLoteFilters, activeLotes]);


    const visibleLotePolygonsFC = React.useMemo(() => {
        const feats = normalizeToFeaturesArray(lotesGeojson);
        if (!hasAnyLoteFilter(appliedLoteFilters)) {
            return { type: 'FeatureCollection', features: feats };
        }
        const filtered = feats.filter((f) => matchLote(f?.properties, appliedLoteFilters));
        return { type: 'FeatureCollection', features: filtered };
    }, [lotesGeojson, appliedLoteFilters]);


    useEffect(() => {
        if (!hasAnyLoteFilter(appliedLoteFilters)) return;
        setActiveLotes([]);
    }, [appliedLoteFilters]);

    const registerUndoHandler = useCallback((handler) => {
        undoHandlerRef.current = typeof handler === 'function' ? handler : null;
    }, []);

    const handleDrawLine = () => {
        setActiveTool((prevTool) => (prevTool === 'draw' ? null : 'draw'));
    };

    const handleCutLine = () => {
        setActiveTool((prevTool) => (prevTool === 'cut' ? null : 'cut'));
    };

    const handleDeleteLine = () => {
        setActiveTool((prevTool) => (prevTool === 'delete' ? null : 'delete'));
    };

    const handleToggleBuffer = () => {
        setIsBufferActive(prev => !prev);
    };

    const handleStretchLine = () => {
        setActiveTool((prevTool) => (prevTool === 'stretch' ? null : 'stretch'));
    };

    const handleMeasurement = () => {
        setActiveTool(prevTool => (prevTool === 'measurement' ? null : 'measurement'));
    };

    const handleUndo = () => {
        try {
            if (undoHandlerRef.current) {
                undoHandlerRef.current();
            } else {
                console.warn("No hay un undoHandler registrado desde el mapa (AerialApplications).");
            }
        } catch (error) {
            console.error("Error al ejecutar handleUndo:", error);
        }
    };

    const toggleUnfilteredLines = () => {
        setShowUnfilteredLines(prev => !prev);
    };

    const procesarOpciones = (opciones) => {
        if (!Array.isArray(opciones)) return [];
        return opciones.flat(Infinity).map(item => String(item));
    };

    const filterOptionsMap = {
        'APLICACIONES_AEREAS': ['operadorCM', 'zafraCM', 'loteCM'],
        'COSECHA_MECANICA': ['operadorCM', 'fincaCM', 'tercioCM'],
        'HERBICIDAS': ['operadorCM', 'fincaCM'],
        'FERTILIZACION': ['operadorCM', 'fincaCM'],
        'CONTEO_PALMA': ['loteCM', 'productoAA'],
        'DETECCION_MALEZA': ['loteCM', 'productoAA'],
    };

    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const userDataLocal = JSON.parse(localStorage.getItem("userData")) || {};
                const idUsuario = userDataLocal.userId;
                if (!idUsuario) {
                    console.error("No se encontró userId en localStorage");
                    return;
                }

                const response = await axios.get(`${API_BASE_URL}dashboard/filtros/${idUsuario}`);
                const data = response.data;

                setOperadorOptionsCM(procesarOpciones(data.operador));
                setZafraOptionsCM(procesarOpciones(data.zafra));
                setLoteOptionsCM(procesarOpciones(data.lote));
                setFincasOptionsCM(procesarOpciones(data.finca));
                setTercioOptionsCM(procesarOpciones(data.tercio));
                setProductoOptionsAA(procesarOpciones(data.producto));

            } catch (error) {
                console.error("Error al obtener los filtros de mapeo:", error);

            } finally {
                setLoadingFilters(false);
            }
        };

        fetchFilters();
    }, []);

    useEffect(() => {
        if (selectedAnalysisType && filterOptionsMap[selectedAnalysisType]) {
            setEnabledFilters(filterOptionsMap[selectedAnalysisType]);
        } else {
            setEnabledFilters([]);
        }
    }, [selectedAnalysisType]);

    const handleSendDashboardDataFilters = async (selectedFiltersParam) => {
        // Este callback SOLO debe actualizar estados locales:
        // - filtrar polígonos
        // - forzar recorte espacial (CommonMap)
        // - y recalcular áreas (AerialApplications)
        // NO debe llamar a endpoints de "aplicar_filtros_backend".
        const next = sanitizeLoteFilters({
            loteId: selectedFiltersParam?.loteId,
            finca: selectedFiltersParam?.finca,
            codigoFinca: selectedFiltersParam?.codigoFinca,
            lote: selectedFiltersParam?.lote,
        });

        setSelectedFilters(next);
        setLoteFilters(next);
        setAppliedLoteFilters(next);

        // Evita que una selección anterior por click "gane" sobre el nuevo filtro
        setActiveLotes([]);
    };

    const handleSendDashboardData = async (imgData, comment) => {
        let avisoPdf = null;
        try {
            if (imgData) {
                setIsGeneratingReport(true);

                let chartsImages = [];
                if (dataSectionRef.current && typeof dataSectionRef.current.exportAllChartsAsImages === "function") {
                    chartsImages = await dataSectionRef.current.exportAllChartsAsImages();
                } else {
                    console.error("dataSectionRef.current.exportAllChartsAsImages NO está definido.");
                }

                // Acercamientos (por lote o por zona); el mapa vuelve a la vista del usuario.
                // Aviso con el paso actual: sin él el botón parecía colgado (Álvaro, 6 oct).
                avisoPdf = toast.info('Preparando el PDF…', { autoClose: false, closeOnClick: false });
                const zoomImages = await capturarAcercamientos(mapRef, filteredPolygonsData, {
                    esperaMaximaMs: 4000,
                    tiempoMaximoMs: 25000,
                    onPaso: (mensaje) => toast.update(avisoPdf, { render: `PDF · ${mensaje}` }),
                });
                toast.update(avisoPdf, { render: 'Generando el PDF en el servidor…' });

                await sendDashboardData(
                    imgData,
                    indicadores,
                    userData.userId,
                    logo,
                    labelsAndColors,
                    comment,
                    tipoMapeo,
                    chartsImages,
                    northWestCoords,
                    southEastCoords,
                    coordinateSystem,
                    idAnalisisUltimoAnalisis || idMax || idAnalisisAps || idAnalisisCosechaMecanica || idAnalisisFertilizacion || idAnalisisHerbicidas,
                    zoomImages
                );
            } else {
                console.error("No se pudo capturar la imagen del mapa.");
            }
        } catch (error) {
            console.error("Error en handleSendDashboardData:", error);
            const mensaje = error?.code === 'ECONNABORTED'
                ? 'El PDF tardó demasiado en generarse. Intenta de nuevo en un momento.'
                : 'No se pudo generar el PDF. Intenta de nuevo en un momento.';
            toast.error(mensaje, { position: toast.POSITION.TOP_RIGHT });
        } finally {
            if (avisoPdf !== null) toast.dismiss(avisoPdf);
            setIsGeneratingReport(false);
        }
    };

    useEffect(() => {
        try {
            obtenerLoteMasReciente(setLoadingPolygons, setPolygonsData, userData.userId, setLotesGeojson);
        } catch (error) {
            console.error("Error en obtenerLoteMasReciente:", error);
        }
    }, [userData.userId]);

    useEffect(() => {
        return () => {
            setDatosMapeo([]);
            setSelectedFile(null);
        };
    }, []);

    useEffect(() => {
        localStorage.removeItem('deteccionMaleza_lotesData');
        localStorage.removeItem('deteccionMaleza_shapefileUrl');
        localStorage.removeItem('deteccionMaleza_datos_temp');
        localStorage.removeItem('deteccionMaleza_idTemp');

        try {
            const storedData = localStorage.getItem('deteccionMaleza_lotesData');
            if (storedData) {
                const parsedData = JSON.parse(storedData);
                if (Array.isArray(parsedData) ||
                    (parsedData && parsedData.timestamp && (Date.now() - parsedData.timestamp) > 24 * 60 * 60 * 1000)) {
                    localStorage.removeItem('deteccionMaleza_lotesData');
                }
            }
        } catch {
            localStorage.removeItem('deteccionMaleza_lotesData');
        }

    }, []);

    useEffect(() => {
        if (socket) {
            socket.on(`${socketSessionID}:progressUpdate`, (data) => {
                try {
                    const progressNumber = Number(data.progress);
                    const message = data.message;
                    const title = data.title;
                    setProgress(progressNumber);
                    setProgressMessage(message);
                    if (title) setTitleLoader(title);
                    setShowProgressBar(progressNumber < 100);

                    if (data?.status === 'error' || data?.error === true) {
                        toast.error(message || 'Ocurrió un error procesando el análisis VRA.', {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 7000,
                        });
                    } else if (progressNumber === 100 && data?.status === 'success') {
                        setProcessingFinished(true);
                        // Análisis en segundo plano (sessionID = job_<id>).
                        fijarJobEnUrl(data?.sessionID);
                        toast.success(message || 'Análisis VRA finalizado correctamente.', {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 5000,
                        });
                    }

                    if (progressNumber === 80) {
                        socket.emit(`${socketSessionID}:progressUpdate`, { progress: 100, message: "Finalizado" });
                        setShowProgressBar(false);
                    }
                } catch (error) {
                    console.error("Error en progressUpdate:", error);
                }
            });

            return () => {
                socket.off(`${socketSessionID}:progressUpdate`);
            };
        }
    }, [socket, socketSessionID]);

    // ── Análisis en segundo plano ────────────────────────────────────────
    // Sala del usuario: avisos de avance aunque el análisis lo haya lanzado
    // otra pestaña o esta antes de recargarse.
    useEffect(() => {
        if (!socket || !userData.userId || modoReporte) return undefined;
        const suscribir = () => socket.emit('analisisJobs:suscribir', { idUsuario: userData.userId });
        suscribir();
        socket.on('connect', suscribir);
        return () => socket.off('connect', suscribir);
    }, [socket, userData.userId, modoReporte]);

    // Créditos por producto (todos los mapeos): el worker descuenta las
    // hectáreas al terminar y avisa a la pestaña que lo lanzó.
    useEffect(() => {
        if (!socket || !socketSessionID) return undefined;
        const evento = `${socketSessionID}:creditosAps`;
        const onCreditos = (data) => notificarConsumoAps(data);
        socket.on(evento, onCreditos);
        return () => socket.off(evento, onCreditos);
    }, [socket, socketSessionID]);

    // Repite los eventos que emitió el GIS durante el análisis para que el
    // mapa, el cálculo de áreas, los indicadores y las gráficas queden igual
    // que en la pestaña que lo vio terminar.
    const [replayListo, setReplayListo] = useState(false);
    useEffect(() => {
        if (!replayCtx || !socket || !socketSessionID) return undefined;
        let cancelado = false;
        (async () => {
            try {
                const ui = replayCtx.ui || {};
                if (ui.appliedLoteFilters) {
                    const filtros = sanitizeLoteFilters(ui.appliedLoteFilters);
                    setSelectedFilters?.(filtros);
                    setLoteFilters(filtros);
                    setAppliedLoteFilters(filtros);
                }
                // Sin setIdMax: un análisis nuevo desde aquí debe crear su propio ID.
                setIsAnalysisPerformed(true);

                // Los componentes del mapa se suscriben al montarse (después
                // de cargar los lotes): se espera a que estén escuchando.
                const eventoMapa = `${socketSessionID}:updateGeoJSONLayer`;
                const limite = Date.now() + 90000;
                while (!cancelado && socket.listeners(eventoMapa).length === 0 && Date.now() < limite) {
                    // eslint-disable-next-line no-await-in-loop
                    await esperar(250);
                }
                await esperar(800);
                if (Array.isArray(ui.activeLotes) && ui.activeLotes.length > 0) setActiveLotes(ui.activeLotes);

                for (const { evento, payload } of replayCtx.eventos || []) {
                    if (cancelado) return;
                    socket.listeners(`${socketSessionID}:${evento}`).forEach((handler) => {
                        try {
                            handler(payload);
                        } catch (error) {
                            console.error(`[ANALISIS_JOB] Error repitiendo ${evento}:`, error);
                        }
                    });
                    // eslint-disable-next-line no-await-in-loop
                    await esperar(evento === 'updateGeoJSONLayer' ? 1200 : 400);
                }
                if (cancelado) return;
                setProcessingFinished(true);
                setShowProgressBar(false);
                setReplayListo(true);
                if (!modoReporte) {
                    marcarJobVisto(replayCtx.job?.id, userData.userId);
                    // «Ver análisis»: el mapa arranca encuadrado en los lotes
                    // y las capas repetidas no lo mueven; se acerca a lo
                    // analizado igual que el PDF automático.
                    const limiteCapas = Date.now() + 30000;
                    while (!cancelado && !mapaTieneAnalisis(obtenerMapa(mapRef)) && Date.now() < limiteCapas) {
                        // eslint-disable-next-line no-await-in-loop
                        await esperar(500);
                    }
                    const map = obtenerMapa(mapRef);
                    if (cancelado || !map) return;
                    await esperarMapaQuieto(map);
                    if (!cancelado) await encuadrarAnalisis(mapRef, estadoReporteRef.current.filteredPolygonsData || []);
                }
            } catch (error) {
                console.error('[ANALISIS_JOB] No se pudo reconstruir el análisis:', error);
                if (modoReporte) reportarEstado('error', { mensaje: `No se pudo reconstruir el análisis: ${error.message}` });
            }
        })();
        return () => { cancelado = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [replayCtx, socket, socketSessionID]);

    // PDF automático (Chrome sin pantalla del worker): cuando todo terminó de
    // cargar, encuadra lo analizado, captura vista general + acercamientos y
    // gráficas, y entrega lo mismo que el botón PDF.
    const estadoReporteRef = useRef({});
    estadoReporteRef.current = {
        indicadores,
        labelsAndColors,
        tipoMapeo,
        northWestCoords,
        southEastCoords,
        coordinateSystem,
        logo,
        filteredPolygonsData,
    };
    const reporteIniciadoRef = useRef(false);
    useEffect(() => {
        if (!modoReporte || !replayListo || !replayCtx || reporteIniciadoRef.current) return;
        reporteIniciadoRef.current = true;
        (async () => {
            try {
                reportarEstado('esperando', { mensaje: 'Esperando a que terminen de cargar el mapa y los indicadores' });
                const limite = Date.now() + 6 * 60 * 1000;
                let estables = 0;
                while (Date.now() < limite && estables < 3) {
                    // eslint-disable-next-line no-await-in-loop
                    await esperarRedQuieta({ quietoMs: 4000, limiteMs: 60000 });
                    const map = obtenerMapa(mapRef);
                    const { indicadores: ind } = estadoReporteRef.current;
                    const hayIndicadores = Boolean(ind && typeof ind === 'object' && ind.analisis);
                    estables = map && mapaTieneAnalisis(map) && hayIndicadores ? estables + 1 : 0;
                    // eslint-disable-next-line no-await-in-loop
                    await esperar(1500);
                }
                const map = obtenerMapa(mapRef);
                if (!map || !mapaTieneAnalisis(map)) throw new Error('El mapa no mostró las capas del análisis.');
                if (!estadoReporteRef.current.indicadores?.analisis) throw new Error('No se cargaron los indicadores del análisis.');

                reportarEstado('capturando', { mensaje: 'Encuadrando el análisis' });
                const lotes = estadoReporteRef.current.filteredPolygonsData || [];
                await encuadrarAnalisis(mapRef, lotes);
                await esperarRedQuieta({ quietoMs: 2500, limiteMs: 60000 });
                await esperarMapaQuieto(map);
                reportarEstado('capturando', { mensaje: 'Vista general' });
                const imgData = await capturarCanvas(map);
                const zoomImages = await capturarAcercamientos(mapRef, lotes, {
                    onPaso: (mensaje) => reportarEstado('capturando', { mensaje }),
                });
                const chartsImages = dataSectionRef.current?.exportAllChartsAsImages
                    ? await dataSectionRef.current.exportAllChartsAsImages()
                    : [];

                // Comentario: el del análisis + propiedades dinámicas, igual que el botón PDF.
                let comment = replayCtx.comentario || '';
                try {
                    const extraProps = JSON.parse(localStorage.getItem(`custom_props_${replayCtx.tipoAnalisis}`) || '[]');
                    const propsAsText = Array.isArray(extraProps)
                        ? extraProps
                            .filter((p) => (p?.label || '').trim() !== '')
                            .map((p) => `• ${p.label}: ${p.value || '-'}`)
                            .join('\n')
                        : '';
                    if (propsAsText) comment = `${comment || ''}\n\n---\nPropiedades:\n${propsAsText}`;
                } catch {
                    // seguir con el comentario original
                }

                const actual = estadoReporteRef.current;
                const { payload } = await construirPayloadReporte(
                    imgData,
                    actual.indicadores,
                    replayCtx.idUsuario,
                    actual.logo,
                    actual.labelsAndColors,
                    comment,
                    actual.tipoMapeo,
                    chartsImages,
                    actual.northWestCoords,
                    actual.southEastCoords,
                    actual.coordinateSystem,
                    replayCtx.idAnalisis,
                    zoomImages
                );
                reportarEstado('enviando', { mensaje: `Generando PDF (${zoomImages.length} acercamientos)` });
                await enviarReporteJob(replayCtx.job?.id, tokenReporte, payload);
                reportarEstado('listo');
            } catch (error) {
                console.error('[REPORTE_AUTO] Error:', error);
                reportarEstado('error', { mensaje: error?.response?.data?.message || error.message });
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modoReporte, replayListo, replayCtx]);

    const handleDatosInsertados = async () => {
        try {
            // Al reabrir un análisis en segundo plano se carga ESE análisis,
            // no el último del usuario (pudo lanzar otros después).
            if (replayAnalisisRef.current?.analisis) {
                setUltimoAnalisis({ data: replayAnalisisRef.current.analisis });
                setIdAnalisisUltimoAnalisis(replayAnalisisRef.current.idAnalisis);
                setRefreshAnalisis(new Date());
                return;
            }
            const config = analysisConfig[selectedAnalysisTypeRef.current];
            if (config && config.cargaDatos) {
                const cargarDatos = await config.cargaDatos(userData, selectedAnalysisTypeRef);
                if (cargarDatos && cargarDatos.data) {
                    setUltimoAnalisis(cargarDatos);
                    setIdAnalisisUltimoAnalisis(cargarDatos.data.ID_ANALISIS);
                } else {
                    console.warn("cargarDatos es null o no contiene data.");
                }
                setRefreshAnalisis(new Date());
            } else {
                toast.warn('Debes seleccionar un tipo de análisis.', {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } catch (error) {
            console.error("Error en handleDatosInsertados:", error);
        }
    };

    useEffect(() => {
        if (socket && socket.on) {
            socket.on(`${socketSessionID}:dataInsertion`, handleDatosInsertados);

            return () => {
                socket.off(`${socketSessionID}:dataInsertion`, handleDatosInsertados);
            };
        }
    }, [socket, socketSessionID]);

    useEffect(() => {
        const config = analysisConfig[selectedAnalysisType];
        if (config && config.fetchData) {
            try {
                if (selectedAnalysisType === 'CONTEO_PALMA') {
                    config.fetchData(conteoObjetos, setDatosAnalisis);
                } else if (selectedAnalysisType === 'CONTEO_AGAVE') {
                    config.fetchData(conteoObjetos, setDatosAnalisis, precioPlantacion, costosPlantacion, utilidadNeta);
                } else if (selectedAnalysisType === 'DETECCION_MALEZA') {
                    config.fetchData(areaMaleza, setDatosAnalisis, areaPoligono, porcentajeMaleza);
                } else {
                    config.fetchData(idAnalisisUltimoAnalisis, setDatosAnalisis);
                }
            } catch (error) {
                console.error("Error en config.fetchData:", error);
            }
        }
    }, [
        idAnalisisCosechaMecanica,
        idAnalisisAps,
        idAnalisisHerbicidas,
        idAnalisisFertilizacion,
        conteoObjetos,
        areaMaleza,
        areaPoligono,
        porcentajeMaleza,
        refreshPeticion,
        selectedAnalysisType,
        idAnalisisUltimoAnalisis,
        precioPlantacion,
        costosPlantacion,
        utilidadNeta
    ]);

    useEffect(() => {
        const syncApsManualRows = () => setApsManualRowsVersion((v) => v + 1);
        window.addEventListener('aplicacionesAereas:manual-rows-actualizadas', syncApsManualRows);
        return () => {
            window.removeEventListener('aplicacionesAereas:manual-rows-actualizadas', syncApsManualRows);
        };
    }, []);

    useEffect(() => {
        let effectiveAnalysisType = selectedAnalysisType;
        if (!effectiveAnalysisType || effectiveAnalysisType.trim() === "") {
            if (selectedSidebarOption) {
                effectiveAnalysisType = selectedSidebarOption
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, "_")
                    .toUpperCase();
            } else {
                console.warn("selectedAnalysisType está vacío y selectedSidebarOption no está definido.");
            }
        }

        let enabled = false;

        const isPlanningSidebar =
            selectedSidebarOption === "Planificación de Herbicidas" ||
            selectedSidebarOption === "Planificación de cosecha";

        if (isPlanningSidebar) {
            enabled = !!selectedFile;
        } else {
            try {
                const config = analysisConfig[selectedAnalysisType];
                if (config && config.shouldEnableExecBash) {
                    enabled = !!config.shouldEnableExecBash(selectedFile || selectedZipFile);
                }
                if (selectedAnalysisType === 'APLICACIONES_AEREAS') {
                    try {
                        const raw = localStorage.getItem('aplicacionesAereas_manual_rows') || '[]';
                        const arr = JSON.parse(raw);
                        enabled = Array.isArray(arr) && arr.length > 0;
                    } catch {
                        enabled = false;
                    }
                }
                if (selectedAnalysisType === 'HERBICIDAS') {
                    try {
                        const raw = localStorage.getItem('herbicidas_manual_rows') || '[]';
                        const arr = JSON.parse(raw);
                        enabled = Array.isArray(arr) && arr.length > 0;
                    } catch {
                        enabled = false;
                    }
                }
            } catch (error) {
                console.error("Error en config.shouldEnableExecBash:", error);
            }
        }

        setExecBashEnabled(enabled);
    }, [selectedAnalysisType, selectedSidebarOption, selectedFile, selectedZipFile, apsManualRowsVersion]);

    useEffect(() => {
        selectedAnalysisTypeRef.current = selectedAnalysisType;
        const config = analysisConfig[selectedAnalysisType];
        const id = config ? config.id : null;
        setIdAnalisisBash(id);
    }, [selectedAnalysisType, userData.userId]);

    useEffect(() => {
        const config = sidebarOptionsConfig[selectedSidebarOption];
        try {
            if (config) {
                setAnalysisOptions(config.analysisOptions || []);
                setDisableAnalysisSelection(config.disableAnalysisSelection || false);
                setForceEnableUploadTemplate(config.enableUploadTemplate || false);
            } else {
                setAnalysisOptions([]);
                setDisableAnalysisSelection(false);
                setForceEnableUploadTemplate(false);
            }
        } catch (error) {
            console.error("Error en sidebarOptionsConfig:", error);
            setAnalysisOptions([]);
            setDisableAnalysisSelection(false);
            setForceEnableUploadTemplate(false);
        }
    }, [selectedSidebarOption]);

    useEffect(() => {
        try {
            if (idAnalisisUltimoAnalisis) {
                setIdAnalisisAps(idAnalisisUltimoAnalisis);
                setIdAnalisisCosechaMecanica(idAnalisisUltimoAnalisis);
                setIdAnalisisFertilizacion(idAnalisisUltimoAnalisis);
                setIdAnalisisHerbicidas(idAnalisisUltimoAnalisis);
                setRefreshPeticion(new Date());
            }
        } catch (error) {
            console.error("Error en setIdAnalisis:", error);
        }
    }, [idAnalisisUltimoAnalisis, refreshAnalisis]);

    // Cosecha Mecánica ya no se vuelve a procesar desde el navegador al
    // cambiar de análisis o al ocultar las líneas de pisoteo: el análisis corre
    // en segundo plano y las líneas son una capa aparte (ver generarLineasPisoteo).

    async function clearAnalysis() {
        const map = mapRef.current;
        if (!map) {
            console.error("Map reference is invalid.");
            return;
        }
        try {
            setDatosAnalisis({});

            if (map.getMap && typeof map.getMap === 'function') {
                const mapboxMap = map.getMap();
                if (mapboxMap && mapboxMap.getStyle) {
                    const style = mapboxMap.getStyle();

                    if (style && style.layers) {
                        const layersToRemove = style.layers
                            .filter(layer =>
                                layer.id.startsWith('analysis-') ||
                                layer.id.startsWith('custom-') ||
                                layer.id.includes('analysis')
                            )
                            .map(layer => layer.id);

                        layersToRemove.forEach(layerId => {
                            if (mapboxMap.getLayer(layerId)) {
                                mapboxMap.removeLayer(layerId);
                            }
                        });

                        if (style.sources) {
                            Object.keys(style.sources)
                                .filter(sourceId =>
                                    sourceId.startsWith('analysis-') ||
                                    sourceId.startsWith('custom-') ||
                                    sourceId.includes('analysis')
                                )
                                .forEach(sourceId => {
                                    if (mapboxMap.getSource(sourceId)) {
                                        mapboxMap.removeSource(sourceId);
                                    }
                                });
                        }
                    }
                }
            } else if (map.getStyle && typeof map.getStyle === 'function') {
                const style = map.getStyle();
                if (style && style.layers) {
                    const layersToRemove = style.layers
                        .filter(layer =>
                            layer.id.startsWith('analysis-') ||
                            layer.id.startsWith('custom-') ||
                            layer.id.includes('analysis')
                        )
                        .map(layer => layer.id);

                    layersToRemove.forEach(layerId => {
                        if (map.getLayer(layerId)) {
                            map.removeLayer(layerId);
                        }
                    });

                    if (style.sources) {
                        Object.keys(style.sources)
                            .filter(sourceId =>
                                sourceId.startsWith('analysis-') ||
                                sourceId.startsWith('custom-') ||
                                sourceId.includes('analysis')
                            )
                            .forEach(sourceId => {
                                if (map.getSource(sourceId)) {
                                    map.removeSource(sourceId);
                                }
                            });
                    }
                }
            }
        } catch (error) {
            console.error("Error clearing analysis:", error);
        }
    }

    function nombreAnalisis(idAnalisis) {
        try {
            const entry = Object.entries(analysisConfig).find(([, config]) => config.id === idAnalisis);
            return entry ? entry[0] : "";
        } catch (error) {
            console.error("Error en nombreAnalisis:", error);
            return "";
        }
    }

    const handleDateChange = (dates) => {
        // Manejar fechas si aplica.
    };

    const handleFileUpload = async (event) => {
        try {
            let currentIdAnalisisBash = idAnalisisBash;
            if (!selectedAnalysisTypeRef.current) {
                if (selectedSidebarOption) {
                    selectedAnalysisTypeRef.current = selectedSidebarOption
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                        .replace(/\s+/g, "_")
                        .toUpperCase();

                    const analysisTypeConfig = analysisConfig[selectedAnalysisTypeRef.current];
                    if (analysisTypeConfig && analysisTypeConfig.id) {
                        currentIdAnalisisBash = analysisTypeConfig.id;
                        setIdAnalisisBash(analysisTypeConfig.id);
                    } else {
                        console.warn(`No se encontró una configuración en analysisConfig para ${selectedAnalysisTypeRef.current}`);
                    }
                } else {
                    console.warn("No se pudo asignar un valor a selectedAnalysisTypeRef.current porque selectedSidebarOption es null o undefined.");
                }
            }

            await manejarSubidaArchivo(
                event,
                setTitleLoader,
                setOpenSnackbar,
                setUploadedCsvFileName,
                selectedAnalysisTypeRef,
                currentIdAnalisisBash || idAnalisisBash,
                nombreAnalisis,
                userData.userId,
                setIdMax,
                setSelectedFile,
                setDatosMapeo,
                setProgress,
                setShowProgressBar,
                setErrors,
                setOpenErrorDialog
            );
        } catch (error) {
            console.error("Error en handleFileUpload:", error);
        }
    };

    const handleCloseErrorDialog = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    const execBash = async (
        generar_lineas = false,
        calidadParam = null,
        materialType = null,
        machineryType = null
    ) => {
        try {
            await clearAnalysis();
            setProgress(0);
            setProgressMessage("");
            setTitleLoader("Cargando Análisis");
            setShowProgressBar(true);
            setIsAnalysisPerformed(true);
            const idUsuario = userData.userId;
            // Filtros de lotes tal como están ahora: el PDF del análisis en
            // segundo plano calcula áreas con los mismos lotes.
            const uiFiltros = { appliedLoteFilters, activeLotes };

            const isPlanningExec =
                selectedSidebarOption === "Planificación de cosecha" ||
                selectedSidebarOption === "Planificación de Herbicidas";

            if (!isPlanningExec && !idAnalisisBash) {
                toast.error('Debe seleccionar un análisis antes de continuar', {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 5000,
                });
                setShowProgressBar(false);
                return;
            }

            // ─────────────────────────────────────────────
            // APLICACIONES AÉREAS
            // ─────────────────────────────────────────────
            if (idAnalisisBash === APLICACIONES_AEREAS) {
                const apsApplicationMode = (localStorage.getItem('aplicacionesAereas_modo') || 'CONVENCIONAL').toUpperCase();

                // ¿Hay filas ingresadas manualmente?
                let hasManualRows = false;
                try {
                    const raw = localStorage.getItem('aplicacionesAereas_manual_rows') || '[]';
                    const arr = JSON.parse(raw);
                    hasManualRows = Array.isArray(arr) && arr.length > 0;
                } catch {
                    hasManualRows = false;
                }

                if (!hasManualRows) {
                    toast.error('Debes ingresar y guardar los datos manuales de Aplicaciones Aéreas antes de ejecutar el análisis.', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                    return;
                }

                if (apsApplicationMode === 'VAR' && (!selectedZipFile || !selectedApsTargetPolygonFile)) {
                    toast.error('Para VRA debes subir el archivo de aplicación (puntos SHP/ZIP, franjas KML/KMZ/ZIP o el .log del controlador) y los polígonos de maleza.', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                    return;
                }

                // ✅ Asegurar SIEMPRE tener id_analisis real en backend para flujo manual
                let idAnalisisParaAps = idMax;

                if (!idAnalisisParaAps || idAnalisisParaAps === '') {
                        try {
                            // Crea el "último análisis" igual que cuando subes plantilla
                            const resp = await insertarUltimoAnalisis(
                                selectedAnalysisTypeRef,
                                idAnalisisBash,
                                nombreAnalisis(idAnalisisBash),
                                idUsuario,
                                {
                                    FORMULACION: materialType || 'LIQUIDO',
                                    TIPO_PRODUCTO: materialType || 'LIQUIDO',
                                    EQUIPO: machineryType || 'DRONE',
                                    MODO_APLICACION: apsApplicationMode,
                                    TIPO_SUB_ANALISIS: apsApplicationMode === 'VAR' ? 'TASA_VARIABLE' : 'NORMAL',
                                    // GEOMETRIA_APLICACION (LINES/POLYGONS) la fija el servicio
                                    // según el archivo de aplicación que se suba.
                                }
                            );
                            // El backend suele devolver { idAnalisis: <id> } o similar
                            idAnalisisParaAps =
                                resp?.data?.idAnalisis ??
                                resp?.data?.ID_ANALISIS ??
                                resp?.data?._id ??
                                String(Date.now());

                            // Mantener todo sincronizado
                            setIdMax(idAnalisisParaAps);
                            localStorage.setItem('aplicacionesAereas_manual_id', String(idAnalisisParaAps));
                        } catch (e) {
                            console.error('No se pudo insertar el análisis (manual APS):', e);
                            // fallback controlado
                            idAnalisisParaAps = String(Date.now());
                            setIdMax(idAnalisisParaAps);
                            localStorage.setItem('aplicacionesAereas_manual_id', idAnalisisParaAps);
                        }
                    }

                await ejecutarProcesoAps({
                    selectedZipFile,
                    idMax: idAnalisisParaAps ?? idMax,
                    idUsuario,
                    setProcessingFinished,
                    socket,
                    socketSessionID,
                    activarEdicionInteractiva,
                    setShowProgressBar,
                    setProgress,
                    setTitleLoader,
                    materialType,
                    machineryType,
                    applicationMode: apsApplicationMode,
                    targetPolygonFile: selectedApsTargetPolygonFile,
                    // VAR: enviar también el polígono visible del lote para que
                    // el servicio GIS persista el área y conserve el lote durante
                    // el análisis, incluso si la capa global se refresca.
                    lotePolygonsGeojson: visibleLotePolygonsFC,
                    uiFiltros
                });
                return;
            }

            // ─────────────────────────────────────────────
            // COSECHA MECÁNICA
            // ─────────────────────────────────────────────
            if (idAnalisisBash === COSECHA_MECANICA) {
                if (generar_lineas) {
                    await generarLineasPisoteo();
                } else if (selectedFile) {
                    // Análisis principal: en segundo plano en el servidor.
                    await lanzarCosechaMecanicaEnSegundoPlano({
                        selectedFile,
                        idMax,
                        idUsuario,
                        socketSessionID,
                        setShowProgressBar,
                        setProgress,
                        setTitleLoader,
                        harvestLinesBuffer,
                        uiFiltros
                    });
                } else {
                    await ejecutarProcesoSinArchivoCosechaMecanica({ setShowProgressBar });
                }
                return;
            }

            // ─────────────────────────────────────────────
            // HERBICIDAS
            // ─────────────────────────────────────────────
            if (idAnalisisBash === HERBICIDAS) {
                // Herbicidas: mismo flujo que Aplicaciones Aéreas (datos manuales +
                // archivo de aplicación), con sus propias claves y endpoints.
                const herbicidasApplicationMode = (localStorage.getItem('herbicidas_modo') || 'CONVENCIONAL').toUpperCase();

                let hasHerbicidasRows = false;
                try {
                    const raw = localStorage.getItem('herbicidas_manual_rows') || '[]';
                    const arr = JSON.parse(raw);
                    hasHerbicidasRows = Array.isArray(arr) && arr.length > 0;
                } catch {
                    hasHerbicidasRows = false;
                }

                if (!hasHerbicidasRows) {
                    toast.error('Debes ingresar y guardar los datos manuales de Herbicidas antes de ejecutar el análisis.', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                    return;
                }

                if (!selectedZipFile) {
                    toast.error(herbicidasApplicationMode === 'VAR'
                        ? 'Debes subir el archivo de aplicación de Herbicidas (franjas KML/KMZ/ZIP, puntos SHP/ZIP o el .log del controlador).'
                        : 'Debes subir el KML/KMZ/ZIP de franjas de aplicación de Herbicidas.', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                    return;
                }

                if (herbicidasApplicationMode === 'VAR' && !selectedApsTargetPolygonFile) {
                    toast.error('Para VRA de Herbicidas debes subir también los polígonos de maleza (SHP/ZIP o KML/KMZ).', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                    return;
                }

                let idAnalisisParaHerbicidas = idMax;
                if (!idAnalisisParaHerbicidas || idAnalisisParaHerbicidas === '') {
                    try {
                        const resp = await insertarUltimoAnalisis(
                            selectedAnalysisTypeRef,
                            idAnalisisBash,
                            nombreAnalisis(idAnalisisBash),
                            idUsuario,
                            {
                                FORMULACION: materialType || 'LIQUIDO',
                                TIPO_PRODUCTO: materialType || 'LIQUIDO',
                                EQUIPO: machineryType || 'DRONE',
                                MODO_APLICACION: herbicidasApplicationMode,
                                TIPO_SUB_ANALISIS: herbicidasApplicationMode === 'VAR' ? 'TASA_VARIABLE' : 'NORMAL',
                                // Normal siempre son franjas; en VRA la geometría la fija
                                // el servicio según el archivo (puntos o franjas).
                                ...(herbicidasApplicationMode === 'VAR' ? {} : { GEOMETRIA_APLICACION: 'POLYGONS' }),
                            }
                        );
                        idAnalisisParaHerbicidas =
                            resp?.data?.idAnalisis ??
                            resp?.data?.ID_ANALISIS ??
                            resp?.data?._id ??
                            String(Date.now());
                        setIdMax(idAnalisisParaHerbicidas);
                        localStorage.setItem('herbicidas_manual_id', String(idAnalisisParaHerbicidas));
                    } catch (e) {
                        console.error('No se pudo insertar el análisis (Herbicidas):', e);
                        idAnalisisParaHerbicidas = String(Date.now());
                        setIdMax(idAnalisisParaHerbicidas);
                        localStorage.setItem('herbicidas_manual_id', idAnalisisParaHerbicidas);
                    }
                }

                await ejecutarProcesoHerbicidas({
                    selectedZipFile,
                    idMax: idAnalisisParaHerbicidas ?? idMax,
                    idUsuario,
                    setProcessingFinished,
                    socketSessionID,
                    activarEdicionInteractiva,
                    setShowProgressBar,
                    setProgress,
                    setTitleLoader,
                    materialType,
                    machineryType,
                    applicationMode: herbicidasApplicationMode,
                    targetPolygonFile: selectedApsTargetPolygonFile,
                    lotePolygonsGeojson: visibleLotePolygonsFC,
                    uiFiltros
                });
                return;
            }

            // ─────────────────────────────────────────────
            // FERTILIZACIÓN
            // ─────────────────────────────────────────────
            if (idAnalisisBash === FERTILIZACION) {
                if (!selectedFile) {
                    await ejecutarProcesoSinArchivoFertilizacion({ setShowProgressBar });
                    return;
                }

                let hasPoints = false;
                if (selectedZipFile) {
                    const formDataZip = new FormData();
                    formDataZip.append("archivo_zip", selectedZipFile);
                    const validarResponse = await axios.post(
                        `${API_BASE_PYTHON_SERVICE}mapping/fertilizacion/validar_zip_shp`,
                        formDataZip,
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                    );
                    hasPoints = !!(validarResponse?.data?.hasPoints);
                }

                const anchoLS = localStorage.getItem('fertilizacion_ancho_faja');
                const anchoFaja = anchoLS ? parseFloat(anchoLS) : null;

                if (hasPoints && (!anchoFaja || isNaN(anchoFaja) || anchoFaja <= 0)) {
                    toast.error('Debe ingresar y guardar el ancho de faja antes de ejecutar el análisis.', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000
                    });
                    setShowProgressBar(false);
                    return;
                }

                const rangos = (JSON.parse(localStorage.getItem('fertilizacion_rangos') || '[null,null,null]'))
                    .map(v => (v === null ? null : Number(v)));

                const analysisKey =
                    selectedAnalysisType && selectedAnalysisType.trim() !== ''
                        ? selectedAnalysisType
                        : selectedSidebarOption
                            ? selectedSidebarOption
                                .normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, '')
                                .replace(/\s+/g, '_')
                                .toUpperCase()
                            : '';

                const customPropsKey = `custom_props_${analysisKey || 'GLOBAL'}`;
                let customProps = [];
                try {
                    const raw = localStorage.getItem(customPropsKey) || '[]';
                    const parsed = JSON.parse(raw);
                    customProps = Array.isArray(parsed) ? parsed : [];
                } catch {
                    customProps = [];
                }

                await ejecutarProcesoFertilizacion({
                    selectedFile,
                    selectedZipFile,
                    idMax,
                    userData,
                    setProcessingFinished,
                    socket,
                    socketSessionID,
                    setProgress,
                    setTitleLoader,
                    setShowProgressBar,
                    anchoFaja: hasPoints ? anchoFaja : null,
                    rangos,
                    customProps,
                    // 👇 opcional: ya puedes usarlo dentro de fertilizacionProcess si quieres
                    materialType,
                    uiFiltros,
                });
                return;
            }

            // ─────────────────────────────────────────────
            // Planificación de cosecha
            // ─────────────────────────────────────────────
            if (selectedSidebarOption === "Planificación de cosecha") {
                if (!selectedFile) {
                    toast.error('Debe seleccionar un archivo para realizar el análisis de Planificación de cosecha.', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                    return;
                }
                await ejecutarPlanificacionCosecha({
                    selectedFile,
                    idMax,
                    idUsuario,
                    setProcessingFinished,
                    socket,
                    socketSessionID,
                    setShowProgressBar,
                    setProgress,
                    setPolygonsHarvestPlanning
                });
                return;
            }

            // ─────────────────────────────────────────────
            // Planificación de Herbicidas
            // ─────────────────────────────────────────────
            if (selectedSidebarOption === "Planificación de Herbicidas") {
                if (!selectedFile) {
                    toast.error('Debe seleccionar un archivo para realizar la Planificación de Herbicidas.', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                    return;
                }
                await ejecutarPlanificacionHerbicidas({
                    selectedFile,
                    idMax,
                    idUsuario,
                    setProcessingFinished,
                    socket,
                    socketSessionID,
                    setShowProgressBar,
                    setProgress,
                    setPolygonsHerbicidesPlanning
                });
                return;
            }

            if (!selectedFile) {
                await ejecutarProcesoSinArchivo();
                return;
            }

        } catch (error) {
            console.error("Error en execBash:", error);
            setShowProgressBar(false);
        }
    };

    const ejecutarProcesoSinArchivo = async () => {
        try {
            const idUsuario = userData.userId;

            if (idAnalisisBash === APLICACIONES_AEREAS) {
                toast.error('Aplicaciones Aéreas ahora requiere datos manuales guardados antes de ejecutar el análisis.', {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 5000,
                });
                setShowProgressBar(false);
                return;
            } else if (idAnalisisBash === COSECHA_MECANICA) {
                await ejecutarProcesoSinArchivoCosechaMecanica({ setShowProgressBar });
            } else if (idAnalisisBash === HERBICIDAS) {
                await ejecutarProcesoSinArchivoHerbicidas({
                    idMax, idUsuario, setProcessingFinished, setShowProgressBar
                });
            } else if (idAnalisisBash === FERTILIZACION) {
                await ejecutarProcesoSinArchivoFertilizacion({ setShowProgressBar });
            } else if (idAnalisisBash === CONTEO_PALMA) {
                const nombre = nombreAnalisis(idAnalisisBash);
                const userId = userData.userId;
                await ejecutarProcesoConteoPalmas({
                    selectedZipFile,
                    setProcessingFinished,
                    setImageUrl,
                    setNorthWestCoords,
                    setSouthEastCoords,
                    setConteoObjetos,
                    socket,
                    socketSessionID,
                    setProgress,
                    setTitleLoader,
                    setShowProgressBar,
                    selectedAnalysisTypeRef,
                    idAnalisisBash,
                    nombre,
                    userId,
                    calidad
                });
            } else if (idAnalisisBash === CONTEO_AGAVE) {
                const nombre = nombreAnalisis(idAnalisisBash);
                const userId = userData.userId;
                await ejecutarProcesoConteoAgaves({
                    selectedZipFile,
                    setProcessingFinished,
                    setImageUrl,
                    setNorthWestCoords,
                    setSouthEastCoords,
                    setConteoObjetos,
                    socket,
                    socketSessionID,
                    setProgress,
                    setTitleLoader,
                    setShowProgressBar,
                    selectedAnalysisTypeRef,
                    idAnalisisBash,
                    nombre,
                    userId,
                    calidad,
                    setCostosPlantacion,
                    setPrecioPlantacion,
                    setUtilidadNeta
                });
            } else if (idAnalisisBash === DETECCION_MALEZA) {
                const nombre = nombreAnalisis(idAnalisisBash);
                const userId = userData.userId;
                try {
                    if (!selectedZipFile) {
                        toast.error("Por favor seleccione un archivo ZIP para detectar maleza.", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 5000,
                        });
                        setShowProgressBar(false);
                        return;
                    }

                    const datosTemp = localStorage.getItem('deteccionMaleza_datos_temp');
                    if (!datosTemp) {
                        toast.error("No se encontraron los datos de la finca. Por favor, complete los datos de la finca primero.", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 5000,
                        });
                        setShowProgressBar(false);
                        return;
                    }

                    const datos = JSON.parse(datosTemp);
                    const idTemporal = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

                    await axios.post(`${API_BASE_URL}deteccion-maleza/datos`, {
                        idAnalisis: idTemporal,
                        nombreFinca: datos.nombreFinca,
                        zafra: datos.zafra,
                        tercio: datos.tercio,
                        fechaFoto: datos.fechaFoto
                    });

                    localStorage.setItem('deteccionMaleza_idTemp', idTemporal);

                    await ejecutarProcesoDeteccionMaleza({
                        selectedZipFile,
                        setProcessingFinished,
                        setImageUrl,
                        setNorthWestCoords,
                        setSouthEastCoords,
                        setAreaMaleza,
                        setPorcentajeMaleza,
                        setAreaPoligono,
                        setDatosAnalisis,
                        socket,
                        socketSessionID,
                        setProgress,
                        setTitleLoader,
                        setShowProgressBar,
                        selectedAnalysisTypeRef,
                        idAnalisisBash,
                        nombre,
                        userId,
                        calidad,
                        idTemporal
                    });
                } catch (malezaError) {
                    console.error("Error en ejecutarProcesoDeteccionMaleza:", malezaError);

                    const idTemporal = localStorage.getItem('deteccionMaleza_idTemp');
                    if (idTemporal) {
                        try {
                            await axios.delete(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}`);
                            localStorage.removeItem('deteccionMaleza_idTemp');
                            localStorage.removeItem('deteccionMaleza_datos_temp');
                        } catch (deleteError) {
                            console.error('Error al eliminar registro:', deleteError);
                        }
                    }

                    toast.error("Ocurrió un error al procesar el archivo de detección de maleza. Por favor, intente nuevamente.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                    setShowProgressBar(false);
                }
            }
        } catch (error) {
            console.error("Error en ejecutarProcesoSinArchivo:", error);
            setShowProgressBar(false);
        }
    };

    const handleAnalysisTypeChange = (event) => {
        try {
            const nextAnalysisType = event.target.value;
            setSelectedAnalysisType(nextAnalysisType);

            if (nextAnalysisType === 'APLICACIONES_AEREAS' || nextAnalysisType === 'HERBICIDAS') {
                // APS y Herbicidas no usan plantilla CSV/Excel; evitamos que quede un archivo de otra vista en memoria.
                setSelectedFile(null);
                setUploadedCsvFileName('');
            }
        } catch (error) {
            console.error("Error en handleAnalysisTypeChange:", error);
        }
    };

    const esValorValido = (valor) => {
        return valor !== '' && valor !== 0 && valor !== null && valor !== undefined;
    };

    const toggleEdicionInteractiva = () => {
        try {
            setActivarEdicionInteractiva(prev => !prev);
        } catch (error) {
            console.error("Error en toggleEdicionInteractiva:", error);
        }
    };

    const onHoverLote = (loteId) => {
        try {
            setHighlightedLote(loteId);
        } catch (error) {
            console.error("Error en onHoverLote:", error);
        }
    };

    const onLeaveLote = () => {
        try {
            setHighlightedLote(null);
        } catch (error) {
            console.error("Error en onLeaveLote:", error);
        }
    };

    const onSelectLote = (loteId) => {
        try {
            const hasToolbarFilters = hasAnyLoteFilter(appliedLoteFilters);

            // Si hay filtros aplicados (ID / N. FINCA / C. FINCA / LOTE),
            // el click NO debe recortar a un solo lote: debe mantener el conjunto filtrado.
            if (hasToolbarFilters) {
                const rows = (Array.isArray(polygonsData) ? polygonsData : []).filter((row) =>
                    matchLote(row, appliedLoteFilters)
                );

                const ids = rows
                    .map((row) => {
                        const p = row?.properties || row || {};
                        return getAnyPropValue(p, [
                            // IDs estándar del sistema
                            'loteId','LOTE_ID','LOTEID','LoteID',
                            'ID_LOTE','id_lote','lote_id',
                            // Variantes comunes en datos externos
                            'LOTE N','LOTE_N','LOTEN',
                            'LOTE','lote','Lote','NUM_LOTE','LOTE_NUM','LOTES',
                            'LOTE 1','LOTE_1','LOTE1',
                            // ESRI/ArcGIS
                            'OBJECTID','OBJECTID_1','OID','oid','FID','fid',
                            // IDs genéricos
                            '_id','id','ID'
                        ]);
                    })
                    .filter((x) => toCleanStr(x));

                const uniqueIds = Array.from(new Set(ids.map((x) => String(x))));

                setActiveLotes((prev) => {
                    const prevSet = new Set((prev || []).map((x) => String(x)));
                    const nextSet = new Set(uniqueIds);
                    const same =
                        prevSet.size === nextSet.size &&
                        Array.from(prevSet).every((v) => nextSet.has(v));
                    return same ? [] : uniqueIds;
                });

                return;
            }

            // Sin filtros: toggle normal del lote clickeado
            const cleanId = String(loteId ?? '').trim();

            // Evitar estados inválidos que hacen que los polígonos "desaparezcan" y no regresen
            if (!cleanId || cleanId === 'Sin ID') {
                setActiveLotes([]);
                return;
            }

            setActiveLotes((prevActiveLotes) => {
                const prev = Array.isArray(prevActiveLotes) ? prevActiveLotes.map((x) => String(x ?? '').trim()) : [];
                return prev.includes(cleanId) ? [] : [cleanId];
            });
        } catch (error) {
            console.error("Error en onSelectLote:", error);
        }
    };

    const clearAllLotes = () => {
        try {
            setActiveLotes([]);
        } catch (error) {
            console.error("Error en clearAllLotes:", error);
        }
    };

    useEffect(() => {
        if (polygonsData.length > 0) {
            setLoadingPolygons(false);
        }
    }, [polygonsData]);

    const closeFilterDialog = () => {
        setIsFilterDialogOpen(false);
    };

    useEffect(() => {
        if (tramplingLines.url) {
            setPreviousTramplingLines(tramplingLines);
        }
    }, [tramplingLines]);

    // Líneas de pisoteo del análisis de Cosecha abierto: se generan en
    // segundo plano en el servidor sin borrar la capa de puntos.
    const generarLineasPisoteo = () => generarLineasPisoteoEnSegundoPlano({
        idAnalisis: idAnalisisUltimoAnalisis || idAnalisisCosechaMecanica || idMax,
        idUsuario: userData.userId,
        socket,
        harvestLinesBuffer,
        setTramplingLines,
        setShowProgressBar,
        setProgress,
        setTitleLoader,
    });

    const handleToggleMostrarLineas = () => {
        setMostrarLineas(prevState => {
            const newState = !prevState;
            if (newState) {
                if (previousTramplingLines && previousTramplingLines.url) {
                    setTramplingLines(previousTramplingLines);
                } else {
                    generarLineasPisoteo().then((ok) => { if (!ok) setMostrarLineas(false); });
                }
            } else {
                setTramplingLines([]);
            }
            return newState;
        });
    };

    useEffect(() => {
        const handleGeneratedPdf = (event) => {
            const detail = event?.detail || {};
            if (detail.saved === false || !detail.idAnalisis) return;

            setGeneratedPdfIds((prev) => {
                const next = Array.from(new Set([...(prev || []).map(String), String(detail.idAnalisis)]));
                persistGeneratedPdfIds(next);
                return next;
            });
        };

        window.addEventListener('geomotica:pdf-report-generated', handleGeneratedPdf);
        return () => window.removeEventListener('geomotica:pdf-report-generated', handleGeneratedPdf);
    }, []);

    const currentReportAnalysisId = (
        idAnalisisUltimoAnalisis ||
        idMax ||
        idAnalisisAps ||
        idAnalisisCosechaMecanica ||
        idAnalisisFertilizacion ||
        idAnalisisHerbicidas ||
        localStorage.getItem('aplicacionesAereas_manual_id') ||
        localStorage.getItem('deteccionMaleza_idReal') ||
        localStorage.getItem('deteccionMaleza_idTemp') ||
        localStorage.getItem('conteoPalma_idAnalisis') ||
        null
    );

    const hasGeneratedPdfForCurrentAnalysis = !!(
        currentReportAnalysisId && generatedPdfIds.includes(String(currentReportAnalysisId))
    );

    const shouldPromptGeneratePdf = !!(
        isAnalysisPerformed &&
        processingFinished &&
        currentReportAnalysisId &&
        !hasGeneratedPdfForCurrentAnalysis
    );

    return (
        <DashboardContainer>
            <Tutorial key={tutorialKey} isActive={runTutorial} onClose={() => setRunTutorial(false)} />
            <ProgressBar
                progress={progress}
                message={progressMessage}
                show={showProgressBar}
                title={titleLoader}
            />
            {!modoReporte && (
                <AnalisisJobsPanel
                    idUsuario={userData.userId}
                    socket={socket}
                    socketSessionID={socketSessionID}
                    jobAbiertoId={replayCtx?.job?.id || null}
                />
            )}
            <ErrorListDialog
                open={openErrorDialog}
                onClose={handleCloseErrorDialog}
                errors={errors}
                title="Errores encontrados en el archivo"
                description="Se han detectado los siguientes errores durante el procesamiento del archivo. Por favor, corrígelos e inténtalo de nuevo."
            />
            <MainContent isSidebarOpen={isSidebarOpen}>
                <div className="dashboard-main">
                    <DashboardControls>
                        <LoadingBar
                            progress={loadingProgress}
                            show={!processingFinished}
                        />
                        <ToolbarComponent
                            selectedAnalysisType={selectedAnalysisType}
                            appliedLoteFilters={appliedLoteFilters}
                            activeLotes={activeLotes}
                            handleAnalysisTypeChange={handleAnalysisTypeChange}
                            manejarSubidaArchivo={handleFileUpload}
                            uploadedCsvFileName={uploadedCsvFileName}
                            uploadedZipFileName={uploadedZipFileName}
                            execBash={execBash}
                            activarEdicionInteractiva={activarEdicionInteractiva}
                            setActivarEdicionInteractiva={setActivarEdicionInteractiva}
                            isKMLFile={isKMLFile}
                            execBashEnabled={execBashEnabled}
                            isSidebarOpen={isSidebarOpen}
                            polygonsData={filteredPolygonsData}
                            highlightedLote={highlightedLote}
                            activeLotes={activeLotes}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onHoverLote={onHoverLote}
                            onLeaveLote={onLeaveLote}
                            onSelectLote={onSelectLote}
                            clearAllLotes={clearAllLotes}
                            openFilterDialog={() => setIsFilterDialogOpen(true)}
                            processingFinished={processingFinished}
                            handleSendDashboardData={handleSendDashboardData}
                            analysisOptions={analysisOptions}
                            setSelectedZipFile={setSelectedZipFile}
                            setUploadedZipFileName={setUploadedZipFileName}
                            selectedApsTargetPolygonFile={selectedApsTargetPolygonFile}
                            setSelectedApsTargetPolygonFile={setSelectedApsTargetPolygonFile}
                            uploadedApsTargetPolygonFileName={uploadedApsTargetPolygonFileName}
                            setUploadedApsTargetPolygonFileName={setUploadedApsTargetPolygonFileName}
                            setOpenSnackbar={setOpenSnackbar}
                            setIsKMLFile={setIsKMLFile}
                            mapRef={mapRef}
                            setImgLaflet={setImgLaflet}
                            isGeneratingReport={isGeneratingReport}
                            setIsGeneratingReport={setIsGeneratingReport}
                            mostrarLineas={mostrarLineas}
                            handleToggleMostrarLineas={handleToggleMostrarLineas}
                            setCalidad={setCalidad}
                            calidad={calidad}
                            disableAnalysisSelection={disableAnalysisSelection}
                            forceEnableUploadTemplate={forceEnableUploadTemplate}
                            selectedSidebarOption={selectedSidebarOption}
                            currentReportAnalysisId={currentReportAnalysisId}
                            hasGeneratedPdfForCurrentAnalysis={hasGeneratedPdfForCurrentAnalysis}
                            shouldPromptGeneratePdf={shouldPromptGeneratePdf}
                        />

                        <FilterToolbar
                            isSidebarOpen={isSidebarOpen}
                            isDashboardIndicators={false}
                            lotesGeojson={lotesGeojson}
                            filterOptions={filterOptions}
                            enabledFilters={enabledFilters}
                            operadorOptions={operadorOptionsCM}
                            zafrasOptions={zafraOptionsCM}
                            loteOptions={loteOptionsCM}
                            fincasOptions={fincasOptionsCM}
                            tercioOptions={tercioOptionsCM}
                            productosOptionsAA={productoOptionsAA}
                            handleDateChange={handleDateChange}
                            onFilterClick={handleSendDashboardDataFilters}
                            handleCutLine={handleCutLine}
                            handleDrawLine={handleDrawLine}
                            handleDeleteLine={handleDeleteLine}
                            handleToggleBuffer={handleToggleBuffer}
                            handleUndo={handleUndo}
                            handleMeasurement={handleMeasurement}
                            activeTool={activeTool}
                            isBufferActive={isBufferActive}
                            bufferValue={bufferValue}
                            setBufferValue={setBufferValue}
                            showUnfilteredLines={showUnfilteredLines}
                            toggleUnfilteredLines={toggleUnfilteredLines}
                            handleStretchLine={handleStretchLine}
                            selectedAnalysisType={selectedAnalysisType}
                            loteFilters={loteFilters}
                            setLoteFilters={setLoteFilters}
                        />
                    </DashboardControls>

                    <MapSectionContainer>
                        {loadingPolygons ? (
                            <Box display="flex" justifyContent="center" alignItems="center" height="400px">
                                <CircularProgress />
                            </Box>
                        ) : (
                            <MapSection
                                selectedFiles={selectedFiles}
                                selectedFile={selectedFile}
                                selectedAnalysisType={selectedAnalysisType}
                                datosMapeo={datosMapeo}
                                selectedZipFile={selectedZipFile}
                                processingFinished={processingFinished}
                                ultimoAnalisis={ultimoAnalisis}
                                nombreAnalisis={nombreAnalisis}
                                idAnalisisBash={idAnalisisBash}
                                activarEdicionInteractiva={activarEdicionInteractiva}
                                setAreaNetaCm={setAreaNetaCm}
                                setAreaBrutaCm={setAreaBrutaCm}
                                setDiferenciaDeAreaCm={setDiferenciaDeAreaCm}
                                setDiferenciaDeAreaApsKml={setDiferenciaDeAreaApsKml}
                                setPorcentajeAreaPilotoCm={setPorcentajeAreaPilotoCm}
                                setPorcentajeAreaAutoTrackerCm={setPorcentajeAreaAutoTrackerCm}
                                setPorcentajeModoCortadorBaseCm={setPorcentajeModoCortadorBaseCm}
                                setEficienciaCm={setEficienciaCm}
                                setAreaSobreAplicada={setAreaSobreAplicada}
                                setAreaTotalLote={setAreaTotalLote}
                                setAreaAplicada={setAreaAplicada}
                                setAreaFueraDeLote={setAreaFueraDeLote}
                                setAreaSobreCalles={setAreaSobreCalles}
                                setPorcentajeVariacion={setPorcentajeVariacion}
                                setPorcentajeVariacionDosis={setPorcentajeVariacionDosis}
                                setAreaNoAplicada={setAreaNoAplicada}
                                setDosisTotalRealAplicada={setDosisTotalRealAplicada}
                                setPromedioVelocidad={setPromedioVelocidad}
                                setPromedioAltura={setPromedioAltura}
                                polygonsData={filteredPolygonsData}
                                visibleLotePolygons={visibleLotePolygonsFC}
                                loteFilters={appliedLoteFilters}
                                highlightedLote={highlightedLote}
                                activeLotes={activeLotes}
                                onHoverLote={onHoverLote}
                                onLeaveLote={onLeaveLote}
                                onSelectLote={onSelectLote}
                                closeFilterDialog={closeFilterDialog}
                                isFilterDialogOpen={isFilterDialogOpen}
                                setImgLaflet={setImgLaflet}
                                imageUrl={imageUrl}
                                northWestCoords={northWestCoords}
                                southEastCoords={southEastCoords}
                                setNorthWestCoords={setNorthWestCoords}
                                setSouthEastCoords={setSouthEastCoords}
                                setCoordinateSystem={setCoordinateSystem}
                                isAnalysisPerformed={isAnalysisPerformed}
                                mapRef={mapRef}
                                polygonsLayerRef={polygonsLayerRef}
                                setLabelsAndColors={setLabelsAndColors}
                                setOnAreasCalculatedLoader={setOnAreasCalculatedLoader}
                                setTipoMapeo={setTipoMapeo}
                                activeTool={activeTool}
                                isBufferActive={isBufferActive}
                                bufferValue={bufferValue}
                                showUnfilteredLines={showUnfilteredLines}
                                setActiveTool={setActiveTool}
                                handleToggleMostrarLineas={handleToggleMostrarLineas}
                                mostrarLineas={mostrarLineas}
                                tramplingLines={tramplingLines}
                                setHarvestLinesBuffer={setHarvestLinesBuffer}
                                polygonsHarvestPlanning={polygonsHarvestPlanning}
                                polygonsHerbicidesPlanning={polygonsHerbicidesPlanning}
                                setFertilizacionShapefileUrl={setFertilizacionShapefileUrl}
                                registerUndoHandler={registerUndoHandler}
                                analisisReabierto={Boolean(replayCtx)}
                            />
                        )}
                    </MapSectionContainer>

                    <AnalysisSection ref={dashboardRef}>
                        <DataSection
                            ref={dataSectionRef}
                            selectedAnalysisType={selectedAnalysisType}
                            promedioAltura={promedioAltura}
                            areaSobreAplicada={areaSobreAplicada}
                            areaTotalLote={areaTotalLote}
                            areaAplicada={areaAplicada}
                            areaTotal
                            areaNoAplicada={areaNoAplicada}
                            diferenciaDeAreaApsKml={diferenciaDeAreaApsKml}
                            areaSobreCalles={areaSobreCalles}
                            areaFueraDeLote={areaFueraDeLote}
                            porcentajeVariacion={porcentajeVariacion}
                            porcentajeVariacionDosis={porcentajeVariacionDosis}
                            promedioVelocidad={promedioVelocidad}
                            areaBrutaCm={areaBrutaCm}
                            eficienciaCm={eficienciaCm}
                            promedioVelocidadCm={promedioVelocidadCm}
                            porcentajeAreaPilotoCm={porcentajeAreaPilotoCm}
                            porcentajeAreaAutoTrackerCm={porcentajeAreaAutoTrackerCm}
                            porcentajeModoCortadorBaseCm={porcentajeModoCortadorBaseCm}
                            esValorValido={esValorValido}
                            setIndicadores={setIndicadores}
                            datosAnalisis={datosAnalisis}
                            conteoObjetos={conteoObjetos}
                            onAreasCalculatedLoader={onAreasCalculatedLoader}
                            dosisTotalRealAplicada={dosisTotalRealAplicada}
                            selectedSidebarOption={selectedSidebarOption}
                            polygonsHarvestPlanning={polygonsHarvestPlanning}
                            polygonsHerbicidesPlanning={polygonsHerbicidesPlanning}
                            fertilizacionShapefileUrl={fertilizacionShapefileUrl}
                            appliedLoteFilters={appliedLoteFilters}
                            activeLotes={activeLotes}

                        />
                    </AnalysisSection>
                </div>
            </MainContent>
        </DashboardContainer>
    );
};

export default Dashboard;
